import { useMemo } from 'react'
import { useQuery, UseQueryOptions } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchContactById } from '../query-api'
import { Contact } from '../types/contact'

type ContactByIdOptions = Pick<UseQueryOptions<{ contact: Contact }>, 'enabled' | 'onSuccess' | 'onError' | 'retry'>

export const useFetchContactById = (contactId?: string | null, options?: ContactByIdOptions) => {
  const { data, error, isLoading, isError, refetch } = useQuery(
    [QueryKeys.Contact, contactId],
    () => fetchContactById(contactId as string),
    {
      enabled: !!contactId,
      ...options,
    },
  )

  const contact = useMemo(() => data?.contact, [data?.contact])

  return { contact, error, isLoading, isError, refetch }
}
